import { TodoItemNode } from './todo-item-node';

/** Flat to-do item node with expandable and level information */
export class TodoItemFlatNode extends TodoItemNode {
    level: number;
    expandable: boolean;
}